export * from 'utils/bolt/showtimes.js';
import hooks from 'utils/hooks';

hooks.register('filters.expand', filtersAvailable => {
	if (filtersAvailable.date) {
		filtersAvailable.date = filtersAvailable.date.filter(d => d !== '2022-10-20');
	}
	return filtersAvailable;
});